export default __webpack_public_path__ + "static/media/verses.33a11834.png";